import { render, staticRenderFns } from "./PerformanceReportTableForm.vue?vue&type=template&id=33c065d5&scoped=true"
import script from "./PerformanceReportTableForm.vue?vue&type=script&lang=js"
export * from "./PerformanceReportTableForm.vue?vue&type=script&lang=js"
import style0 from "./PerformanceReportTableForm.vue?vue&type=style&index=0&id=33c065d5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c065d5",
  null
  
)

export default component.exports